var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-2 text-xs px-2 py-0.5 rounded",class:_vm.typeId == 1
      ? 'bg-blue-100 text-blue-700'
      : 'bg-purple-100 text-purple-700'},[_vm._v(" "+_vm._s(_vm.typeId == 1 ? "Spot" : "Toplu")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }